import React, { useState } from "react";
import "./QuizEngine.css";

function QuizEngine({
  quiz,
  onBack,
  onComplete,
}) {
  const [currentQuestionIndex, setCurrentQuestionIndex] =
    useState(0);

  const [selectedAnswers, setSelectedAnswers] =
    useState({});

  const [showResults, setShowResults] = useState(false);

  if (!quiz || !quiz.questions?.length) {
    return null;
  }

  const currentQuestion =
    quiz.questions[currentQuestionIndex];

  const selectedAnswer =
    selectedAnswers[currentQuestion.id];

  const answeredQuestions = Object.keys(
    selectedAnswers
  ).length;

  const score = quiz.questions.reduce(
    (total, question) => {
      const answer =
        selectedAnswers[question.id];

      return answer === question.correctAnswer
        ? total + 1
        : total;
    },
    0
  );

  const scorePercent = Math.round(
    (score / quiz.questions.length) * 100
  );

  const handleSelectAnswer = (answerId) => {
    setSelectedAnswers((currentAnswers) => ({
      ...currentAnswers,
      [currentQuestion.id]: answerId,
    }));
  };

  const handleNextQuestion = () => {
    if (
      currentQuestionIndex <
      quiz.questions.length - 1
    ) {
      setCurrentQuestionIndex(
        (currentIndex) => currentIndex + 1
      );

      return;
    }

    const finalScore = quiz.questions.reduce(
      (total, question) => {
        const answer =
          selectedAnswers[question.id];

        return answer === question.correctAnswer
          ? total + 1
          : total;
      },
      0
    );

    const finalScorePercent = Math.round(
      (finalScore / quiz.questions.length) * 100
    );

    setShowResults(true);

    if (onComplete) {
      onComplete({
        quizId: quiz.id,
        score: finalScore,
        scorePercent: finalScorePercent,
        passed:
          finalScorePercent >= quiz.passingScore,
      });
    }
  };

  const handlePreviousQuestion = () => {
    if (currentQuestionIndex === 0) {
      return;
    }

    setCurrentQuestionIndex(
      (currentIndex) => currentIndex - 1
    );
  };

  const handleRestartQuiz = () => {
    setCurrentQuestionIndex(0);
    setSelectedAnswers({});
    setShowResults(false);
  };

  if (showResults) {
    const passed =
      scorePercent >= quiz.passingScore;

    return (
      <section className="quizEngine">
        <button
          type="button"
          className="quizBackButton"
          onClick={onBack}
        >
          ← Back to Lesson
        </button>

        <div className="quizResultsCard">
          <span className="quizEyebrow">
            QUIZ COMPLETE
          </span>

          <div className="quizResultIcon">
            {passed ? "🏆" : "📘"}
          </div>

          <h1>
            {passed
              ? "You passed!"
              : "Keep learning"}
          </h1>

          <strong>
            {score} of {quiz.questions.length} correct
          </strong>

          <div className="quizScoreTrack">
            <div
              className="quizScoreFill"
              style={{
                width: `${scorePercent}%`,
              }}
            />
          </div>

          <p>
            Your score was {scorePercent}%. A score of{" "}
            {quiz.passingScore}% is required to pass.
          </p>

          <div className="quizResultActions">
            <button
              type="button"
              className="quizPrimaryButton"
              onClick={handleRestartQuiz}
            >
              Try Again
            </button>

            <button
              type="button"
              className="quizSecondaryButton"
              onClick={onBack}
            >
              Return to Lesson
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="quizEngine">
      <button
        type="button"
        className="quizBackButton"
        onClick={onBack}
      >
        ← Back to Lesson
      </button>

      <header className="quizHeader">
        <div>
          <span className="quizEyebrow">
            KNOWLEDGE CHECK
          </span>

          <h1>{quiz.title}</h1>

          <p>{quiz.description}</p>
        </div>

        <div className="quizProgressCard">
          <span>QUESTION</span>

          <strong>
            {currentQuestionIndex + 1} of{" "}
            {quiz.questions.length}
          </strong>

          <p>
            {answeredQuestions} answered
          </p>
        </div>
      </header>

      <div className="quizContent">
        <div className="quizQuestionCard">
          <span className="quizQuestionNumber">
            Question {currentQuestionIndex + 1}
          </span>

          <h2>{currentQuestion.question}</h2>

          <div className="quizAnswerList">
            {currentQuestion.answers.map(
              (answer) => (
                <button
                  type="button"
                  key={answer.id}
                  className={
                    selectedAnswer === answer.id
                      ? "quizAnswerButton quizAnswerButtonSelected"
                      : "quizAnswerButton"
                  }
                  onClick={() =>
                    handleSelectAnswer(answer.id)
                  }
                >
                  <span>{answer.label}</span>

                  <strong>{answer.text}</strong>
                </button>
              )
            )}
          </div>
        </div>

        <footer className="quizNavigation">
          <button
            type="button"
            className="quizSecondaryButton"
            disabled={currentQuestionIndex === 0}
            onClick={handlePreviousQuestion}
          >
            Previous
          </button>

          <button
            type="button"
            className="quizPrimaryButton"
            disabled={!selectedAnswer}
            onClick={handleNextQuestion}
          >
            {currentQuestionIndex ===
            quiz.questions.length - 1
              ? "Finish Quiz"
              : "Next Question"}
          </button>
        </footer>
      </div>
    </section>
  );
}

export default QuizEngine;